
<template>
  <div class="info--text">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NewDocumentTemplateCategoryDescription'
}
</script>
